module.exports = __webpack_public_path__ + "img/braun.b640e46.png";